<template>
  <el-dialog title='分配运输车' :visible.sync='driverDialogVisible' width='750px' height='500' center
             @close='distributionClose'>
    <div class='detail2' v-loading='driverDialogLoading'>
      <el-form ref='distribution' label-width='110px' :rules='distriRules' class='demo-ruleForm'
               size='mini'
               :model='distriForm'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <el-form-item label='供应商名称:'>{{ detailData.fleetName }}</el-form-item>
            <el-row>
              <el-col :span='12'>
                <el-form-item label='起始区域:' class='mb0'>
                  <span>{{ detailData.startName }}</span>
                  <span v-if='detailData.startType === 1'>【{{ detailData.startPortName }}】</span>
                  <div class='addressItem'>{{ detailData.startDetail }}</div>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='交车区域:' class='mb0'>
                  <span>{{ detailData.deliveryName }}</span>
                  <span v-if='detailData.deliveryType==1'>【{{ detailData.deliveryPortName
                    }}】</span>
                  <div class='addressItem'>{{ detailData.deliveryDetail }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='12'>
                <el-form-item label='预装车数量:'>{{ detailData.fleetCount }}</el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='待装车数量:'>{{ detailData.surplusCount }}</el-form-item>
              </el-col>
            </el-row>
            <el-form-item label='预装车时间:'> {{ detailData.entruckTime }}</el-form-item>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>已选择车辆</span>
          </div>
          <div class='operationTable'>
            <el-table
              :data='detailData.driverList'
              class='w100'
              border
              :header-cell-style='headerCellStyle'
              :cell-style='cellStyle'
              ref='selectCar'
            >
              <el-table-column type='index' label='序号' align='center'></el-table-column>
              <el-table-column prop='truckName' label='车牌号' align='center' width='200px'>
                <template slot-scope='scope'>
                  {{ scope.row.truckName }}
                </template>
              </el-table-column>
              <el-table-column prop='driverName' label='司机姓名' align='center' width='' />
              <el-table-column prop='driverTel' label='司机电话' align='center' width='' />
              <el-table-column label='操作' align='center'>
                <template slot-scope='scope'>
                  <span v-show='scope.row.status !== 0'>--</span>
                  <i v-show='scope.row.status === 0' class='el-icon-error font-size-26'
                     @click='deles(scope.$index)' />
                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>选择车辆</span>
          </div>
          <div class='operationTable'>
            <el-table
              :data='distriForm.vehicleData'
              class='w100'
              border
              :header-cell-style='headerCellStyle'
              :cell-style='cellStyle'
              ref='selectCar'
            >
              <el-table-column type='index' label='序号' align='center'></el-table-column>
              <el-table-column prop='truckName' label='车牌号' align='center' width='200px'>
                <template slot-scope='scope'>
                  {{ scope.row.truckName }}
                </template>
              </el-table-column>
              <el-table-column prop='driverName' label='司机姓名' align='center' width='' />
              <el-table-column prop='driverTel' label='司机电话' align='center' width='' />
              <el-table-column label='操作' align='center'>
                <template slot-scope='scope'>
                  <i class='el-icon-circle-plus font-size-26'
                     @click='addMaterial(scope.$index)' />
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class='mt15 w100 flex-center-center'>
            <el-button class='searchBtn' :loading='addLoad' @click='addClick2' size='small'>确定
            </el-button>
            <el-button class='resetBtn' @click='distributionClose' size='small'>关闭</el-button>
          </div>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import {
  vehicleDeploygetDistributionByCar,
  vehicleDeployInfoCvAddTransportVehicle
} from '@/service/vehiclelog'

export default {
  name: 'carDriver',
  data() {
    return {
      driverDialogVisible: false,  // 分配运输车显隐
      driverDialogLoading: false,
      detailData: {},
      addLoad: false,
      distriRules: {
        license: [
          {
            required: true,
            message: '请输入车牌号',
            trigger: 'blur'
          }
        ],
        vehicleType: [
          {
            required: true,
            message: '请选择车辆类型',
            trigger: 'blur'
          }
        ],
        fleet: [
          {
            required: true,
            message: '请选择车队',
            trigger: 'blur'
          }
        ],
        vehicleStatus: [
          {
            required: true,
            message: '请选择车辆状态',
            trigger: 'blur'
          }
        ],
        driverName: [
          {
            required: true,
            message: '请输入司机姓名',
            trigger: 'blur'
          }
        ],
        driverTelephone: [
          {
            required: true,
            message: '请输入司机电话',
            trigger: 'blur'
          }
        ]
      },
      // 分配运输车数据
      distriForm: {
        fleet: '',
        vehicleData: [
          {
            truckName: '',
            vehicleType: '',
            vehicleStatus: '',
            driverName: '',
            driverTelephone: ''
          }
        ]
      },
      headerCellStyle: {
        color: '#7F7F7F',
        'font-size': '13px',
        height: '35px'
      },
      cellStyle: {
        'color': '#7F7F7F',
        'font-size': '13px'
      }
    }
  },
  methods: {
    // 打开分配运输车弹出框
    async openDialog(id) {
      this.driverDialogVisible = true
      this.driverDialogLoading = true
      const res = await vehicleDeploygetDistributionByCar({ distributionId: id })
      if (res.status !== 0) return this.$message.error(res.message)
      this.detailData = res.data
      //下拉数据  车list
      this.supplierCarList = res.data.childList
      //修改数据结构 ，两个保持一致
      this.distriForm.vehicleData = res.data.childList.map(item => {
        return {
          driverId: item.driverId,
          driverName: item.name,
          truckId: item.id,
          truckName: item.license,
          driverTel: item.phoneNumber
        }
      })
      //已选择的车辆
      this.detailData.driverList.map(item => {
        return {
          driverId: item.driverId,
          driverName: item.driverName,
          truckId: item.truckId,
          truckName: item.truckName
        }
      })
      this.driverDialogLoading = false
    },
    // 分配运输车 —— 取消
    distributionClose() {
      this.driverDialogVisible = false
      this.detailData = {}
      this.distriForm = {
        fleet: '',
        vehicleData: [
          {
            truckName: '',
            vehicleType: '',
            vehicleStatus: '',
            driverName: '',
            driverTelephone: ''
          }
        ]
      }
    },
    // 分配运输车 —— 操作（删除）
    deles(index) {
      //已选择车辆 添加到 未选
      let arr = this.detailData.driverList.splice(index, 1)
      arr.forEach(item => {
        this.distriForm.vehicleData.push(item)
      })
    },
    // 分配运输车 —— 操作（添加）
    addMaterial(index) {
      //未选择车辆 添加到 已选
      let arr = this.distriForm.vehicleData.splice(index, 1)
      arr.forEach(item => {
        item.status = 0
        this.detailData.driverList.push(item)
      })
    },
    // 分配运输车 —— 确认
    async addClick2() {
      await this.$refs.distribution.validate(async (valid) => {
        if (valid) {
          let driverList = []
          if (this.detailData.driverList.length > 0) {
            this.detailData.driverList.forEach(item => {
              if (item.status === 0) {
                driverList.push({
                  truckId: item.truckId,
                  truckName: item.truckName,
                  driverName: item.driverName,
                  driverId: item.driverId
                })
              }
            })
          }
          let obj = {
            id: this.detailData.id,
            driverList: driverList
          }
          console.log(obj)
          // return false
          this.addLoad = true
          const res = await vehicleDeployInfoCvAddTransportVehicle(obj)
          this.addLoad = false
          if (res.status !== 0) return this.$message.error(res.message)
          this.$message.success(res.message)
          this.driverDialogVisible = false
          await this.$emit('getList')

        } else {

        }
      })


    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep.detail2 {
  width: 100%;
  padding: 10px 0 20px 20px;
  max-height: 70vh;
  overflow-y: auto;

  .tableAddBtnContainer {
    border: 1px solid #EBEEF5;;
    border-top-style: none;
    width: 100%;
    //height: 35px;
    display: flex;
    align-items: center;
    //padding-left: 15px;
    ::v-deep {
      .el-select .el-input.is-focus .el-input__inner {
        border-color: #DCDFE6;
      }

      .el-select .el-input__inner:focus {
        border-color: #DCDFE6;
      }
    }

    .AddContainer {
      display: flex;
      align-items: center;

      &:hover {
        cursor: pointer;
      }
    }

    img {
      object-fit: cover;
      margin-right: 5px;
    }

    p {
      font-size: 13px;
      color: #F59A23;
      font-family: 'Arial Normal', 'Arial', sans-serif;
    }

    .addBtn {
      outline: none;
      width: 100%;
      color: #3d3d3d;
      background-color: #fff;
      border: 1px solid #CECECE;
      font-size: 12px;
      height: 20px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .el-table td {
    padding: 5px 0;
  }

  .baseInfo {
    display: flex;
    flex-direction: column;

    &Title {
      display: flex;
      align-items: flex-end;

      p {
        font-weight: 700;
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        margin-left: 10px;
      }
    }

    &Content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px 23px 0 0px;

      .addressItem {
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 10px;
        margin-left: 70px;
      }

      .el-form-item__label {
        font-weight: 700;
      }
    }
  }

  .operation {
    display: flex;
    flex-direction: column;

    .el-form-item {
      margin-bottom: 0 !important;
    }

    ::v-deep {
      .cell {
        font-size: 10px;
        padding: 0;
      }
    }

    &Title {
      display: flex;
      align-items: flex-end;

      p {
        font-weight: 700;
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        margin-left: 10px;
      }
    }

    &Table {
      width: 100%;
      margin-top: 10px;
      padding: 0 20px;


    }
  }

  ::v-deep {
    .el-input--mini .el-input__inner {
      width: 100%;
    }

    .cell {
      font-size: 10px;
      padding: 0;
    }

    .el-table td, .el-table th {
      padding: 0;
    }
  }
}
</style>
